import React, { useState } from 'react';

export default function Home(props){

    return (
        <main>
        <div style={{textAlign:'center'}}>
            <h2>404 ! oops , something lost.</h2>
        </div>
        </main>
    )
}